const content = {
    twitter: 'https://twitter.com/townesmusic',
    facebook: 'https://www.facebook.com/townesmusic/',
    instagram: 'https://www.instagram.com/townes.mr/'
};
  
export default content;
  
